// Home v2 (mobile-web) — POI batch progress strip.
//
// Renders between the balance card and the token list while RAILGUN is
// processing a POI batch (e.g. "Processing POI batch …"). Mirrors the extension
// DashboardScreen banner gated on `mode === PRIVATE && batch`. Unlike the
// in-card pending badges, this sits on the PAGE background, so it uses theme
// tokens (not white-on-gradient) to stay legible in both dark and light themes.
import React from 'react'
import { View } from 'react-native'

import PureSpinner from '@common/assets/svg/PureSpinner'
import Text from '@common/components/Text'
import useTheme from '@common/hooks/useTheme'
import { ModeEnum, type Mode } from '@web/contexts/appModeContext'
import useRailgunBatchUpdate from '@web/hooks/useRailgunBatchUpdate'

type Props = {
  mode: Mode
}

const BatchProgressBanner: React.FC<Props> = ({ mode }) => {
  const { theme } = useTheme()
  const batch = useRailgunBatchUpdate()

  if (mode !== ModeEnum.PRIVATE || !batch) return null

  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8
      }}
    >
      <PureSpinner style={{ width: 20, height: 20 }} color={theme.primary} />
      <Text fontSize={12} weight="semiBold" color={theme.secondaryText}>
        {batch.status}
      </Text>
    </View>
  )
}

export default React.memo(BatchProgressBanner)
